import styled from 'styled-components';
import { BodySmall, BodySmallMedium } from '@src/fonts/typography/Typography';

export const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  width: 100%;

  #close-icon {
    color: #393939;
    flex-shrink: 0;
    cursor: pointer;
  }

  span {
    ${BodySmall};
    color: inherit;
    line-height: normal;
  }
`;

export const FeedbackContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;

  span {
    ${BodySmallMedium};
    color: inherit;
    font: inherit;
    line-height: normal;
  }
`;
